import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import HelpArticleLink from "../Common/HelpArticleLink";
import { HELP_ARTICLE_PROFESSIONALS } from "../../helpers/helpCenter";

type ServiceCoverageNoticeProps = {
  message: string;
  showSettingsLink: boolean;
};

const ServiceCoverageNotice = ({
  message,
  showSettingsLink,
}: ServiceCoverageNoticeProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-3">
      <p className="mb-2">{message}</p>
      <p className="text-muted small mb-2">
        {t("studio.professionals.specialty.inlineHelp")}
      </p>
      <div className="d-flex flex-wrap align-items-center gap-3">
        {showSettingsLink ? (
          <Link to="/settings/general">
            {t("studio.professionals.specialty.restrictLink")}
          </Link>
        ) : null}
        <HelpArticleLink
          articlePath={HELP_ARTICLE_PROFESSIONALS}
          label={t("studio.professionals.specialty.helpLink")}
        />
      </div>
    </div>
  );
};

export default ServiceCoverageNotice;
